// React
import React from 'react';

// Components
import { MainCard } from 'components';

// Packages
import { Grid, Box, Stack, Button } from '@mui/material';

// Utils
import { REGISTER_USER } from 'utils/route-constants';

const RegistrationError = ({ error, resetForm, navigate }) => {
    return (
        <Grid
            item
            sm={8}
            sx={{
                backgroundColor: 'rgba(33, 35, 34, 0.05)',
                height: '100vh',
                padding: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <MainCard
                style={{
                    padding: '10px 20px',
                    width: '80%',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    alignItems: 'center'
                }}
                className="oeError"
            >
                <Box sx={{ width: '100%' }}>
                    <Stack sx={{ width: '100%' }}>
                        <h2 className="oeLarge" style={{ marginBottom: '5px' }}>
                            We ran into an issue.
                        </h2>
                        <Stack
                            sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <Stack
                                spacing={4}
                                sx={{ textAlign: 'center', marginBottom: '10px' }}
                            >
                                <p style={{ fontWeight: '700' }}>{error.title}</p>
                            </Stack>
                            <Stack
                                direction="column"
                                spacing={2}
                                sx={{ textAlign: 'center', marginBottom: '20px' }}
                            >
                                <p>{error.message}</p>
                            </Stack>
                        </Stack>
                    </Stack>
                </Box>
                <Stack
                    direction={
                        error?.title === 'Existing Invitation' ? 'row' : 'column'
                    }
                    spacing={2}
                    sx={{
                        width: '100%',
                        alignItems: 'stretch'
                    }}
                >
                    {error?.title === 'Existing Invitation' && (
                        <Button
                            className="oeOccupant"
                            fullWidth
                            variant="contained"
                            size="large"
                            sx={{
                                color: 'white',
                                '&:hover': {
                                    color: 'white'
                                }
                            }}
                            onClick={() => {
                                resetForm('hard');
                                navigate(REGISTER_USER);
                            }}
                        >
                            Activate Account
                        </Button>
                    )}
                    <Button
                        className="oeErrorBtn"
                        fullWidth
                        variant="contained"
                        size="large"
                        onClick={() => {
                            resetForm('soft');
                        }}
                    >
                        Try Again
                    </Button>
                </Stack>
            </MainCard>
        </Grid>
    );
};

export default RegistrationError;
